import PropTypes from 'prop-types';

import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { NumberedSectionNumber as SectionNumber } from './NumberedSection.style';

function NumberedSection({ children, description, sectionNumber, title, ...delegated }) {
  return (
    <Stack component="section" gap={1} {...delegated}>
      <Stack component="header" gap={1} sx={{ pl: 1, pr: 1 }}>
        <Stack alignItems="center" direction="row" gap={1}>
          <SectionNumber>{sectionNumber}</SectionNumber>
          <Heading color="primary" component="h2" size="lg" weight="medium" wrap="wrap">
            {title}
          </Heading>
        </Stack>
        {description && <Text>{description}</Text>}
      </Stack>
      {children}
    </Stack>
  );
}

NumberedSection.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.node,
  sectionNumber: PropTypes.number.isRequired,
  title: PropTypes.node.isRequired
};

export default NumberedSection;
